import React from 'react'
import { useSelector } from 'react-redux'
import GameInactivePage from './index'
import { useGameAvailability } from './useGameAvailability'

const GameAvailabilityGate = ({ gameId, children }) => {
  const accountInactive = useSelector((state) => state.auth?.accountInactive)
  const { checking, inactive, gameName } = useGameAvailability(gameId)

  if (accountInactive) {
    return (
      <GameInactivePage
        kicker='Account inactive'
        heading='Your account is inactive'
        message='This account has been turned off. You cannot join a table or start a session until it is active again.'
        showMoreGames={false}
      />
    )
  }

  if (checking) return null
  if (inactive) return <GameInactivePage gameName={gameName} gameId={gameId} />
  return children
}

export default GameAvailabilityGate
